import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import { EndpointQueryParameters } from '../../types/strapi/strapi'
import User from '../../types/api/user'
import getQuery from '../../helpers/api/get-query'

export const usersApi = createApi({
    reducerPath: 'usersApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['User'],
    endpoints: builder => ({
        getUsers: builder.query<User[], EndpointQueryParameters | void>({
            query: getQuery('/users'),
            providesTags: ['User'],
        }),
        updateUser: builder.mutation<User, { id: number; phoneNumber: string }>({
            query: ({ id, phoneNumber }) => ({
                url: `/users/${id}`,
                method: 'PUT',
                body: { phoneNumber },
            }),
            invalidatesTags: ['User'],
        }),
    }),
})

export const { useGetUsersQuery, useUpdateUserMutation } = usersApi
